<!-- TABLE SECTION (SCREEN ONLY) -->
<section class="content">
  <div class="container-fluid">
    <div class="py-1"></div>
    <!-- SEARCH -->
    <div class="row mt-3">
      <div class="d-flex justify-content-end">
        <div class="col-lg-4">
          <div class="form-floating">
            <input type="search" class="form-control" placeholder="search" [(ngModel)]="searchText">
            <label>Search</label>
          </div>
        </div>
      </div>
    </div>

    <!-- TABLE -->
    <div class="row mt-3">
      <div class="table-style table-responsive table-bordered">
        <table class="table table-head-fixed text-nowrap text-center">
          <thead>
            <tr>
              <th>S.No</th>
              <th>Product</th>
              <th>Barcode</th>
              <th>Size</th>
              <th>Qty</th>
              <th>Print</th>
              <th>Bulk Print</th>
            </tr>
          </thead>
          <tbody *ngIf="products.length > 0">
            <tr *ngFor="let item of products | filter:searchText; let i=index">
              <td>{{ i + 1 }}</td>
              <td>{{ item.productName }}</td>
              <td>{{ item.barcodeNumber }}</td>
              <td>{{ item.size }}</td>
              <td>{{ item.varientQuantity }}</td>
              <td>
                <button type="button" class="btn btn-success" (click)="printSelectedProduct(item)">
                  <i class="fa fa-print"></i> Print
                </button>
              </td>
              <td>
                <button type="button" class="btn btn-primary btn-sm" (click)="bulkPrintByProduct(item.productId)">
                  <i class="fa fa-print"></i> Bulk Print
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

  </div>
</section>

<div class="modal-wrapper" role="dialog" aria-modal="true" *ngIf="showVariantPopup">
  <div class="modal-content p-4 rounded shadow-lg" (click)="$event.stopPropagation()">
    <div class="modal-header d-flex justify-content-between align-items-center mb-3">
      <h5 class="modal-title">Add Variants Count</h5>
      <button type="button" class="btn-close" (click)="cancelVariantPopup()"></button>
    </div>
    <div class="modal-body">
      <label class="fw-semibold">Number of Variants</label>
      <input type="number" min="1" class="form-control mt-2" [(ngModel)]="sareeVariantCount">
    </div>
    <div class="modal-footer d-flex justify-content-end gap-2 mt-3">
      <button class="btn btn-secondary" (click)="cancelVariantPopup()">Cancel</button>
      <button class="btn btn-primary" (click)="confirmVariantCount()">Confirm</button>
    </div>
  </div>
</div>


<!-- ================= PRINT LABELS ================= -->
<div class="print-wrapper" #printWrapper>
  <div class="label" *ngFor="let item of products; let i = index">
    <svg class="barcode" [attr.id]="'barcode-' + i">
    </svg>

    <div class="text">
      <div class="code">{{ item.barcodeNumber }}</div>
      <div class="name">{{ item.productName }}</div>
      <div class="price">₹ {{formatAmount(item.productSrp) }}</div>

      <div *ngFor="let dis of item.discountDetails">
        {{ dis.discountQuqntity }}'s - {{ dis.discountAmount }}
      </div>
    </div>
  </div>
</div>